import React, { useState, useMemo } from 'react';
import { ZoneViewProductCategorySelect } from '../../product-category-select/ZoneViewProductCategorySelect';
import { XInput } from '../../../x/input/XInput';
import { MenuProductList } from '../../../menu-product/list/MenuProductList';
import { XSection } from '@orderx/lab/ui';
import { useMenuProductCategory } from '../../../../hooks/menu-product-category';
import { MenuProduct } from '../../../../XV2';
import { useZone } from '../../../../hooks/zone';
import { useActiveOrder } from '../../../../hooks/active-order';
import './ZoneViewMenuLayoutDefault.scss';
import { ZoneViewActiveOrder } from '../../active-order/ZoneViewActiveOrder';
import { stringIncludes } from '../../../../util/stringIncludes';

export function ZoneViewMenuLayoutDefault() {
    const { response } = useZone();
    const activeOrder = useActiveOrder();
    const { hasActiveOrder, getCountByProductId } = activeOrder;
    const menuProductCategory = useMenuProductCategory();
    const [keyword, setKeyword] = useState('');
    const menu = response?.menu || [];

    const menuProducts = useMemo<MenuProduct[]>(() => {
        if (keyword) {
            return menu.filter((menuProduct) => stringIncludes(menuProduct.product.name, keyword));
        } else {
            return hasActiveOrder && menuProductCategory.category === 'MY_ORDER'
                ? menu.filter(({ productId }) => getCountByProductId(productId) > 0)
                : menuProductCategory.filterProducts(menu);
        }
    }, [menu, keyword, hasActiveOrder, menuProductCategory.category, getCountByProductId]);

    if (menuProductCategory.isMyOrderActive()) {
        return <ZoneViewActiveOrder />;
    }

    return (
        <div className={'ZoneViewMenuLayoutDefault'}>
            <ZoneViewProductCategorySelect />

            <XSection>
                <XInput
                    value={keyword}
                    onChangeValue={setKeyword}
                    placeholder="Search for product"
                    iconStart="search"
                    clearable
                />
            </XSection>

            <XSection>
                <MenuProductList menuProducts={menuProducts} />
            </XSection>
        </div>
    );
}
